import React, { Fragment } from "react"
import { BreadCrumb } from 'primereact/breadcrumb';
import { useNavigate } from "react-router-dom";
import './breadCrump.css'
import PropTypes from 'prop-types';


function BreadCrumbComp({ items }) {
  const navigate = useNavigate()

  const titems = []
  const home = { label: 'Home', command: () => navigate("/") }
  items.map((val) => {
    if (val.id !== (items.length - 1).toString()) {
      if (val.value === "dataAssets") {
        titems.push({ ...val, command: () => navigate("/dataAssets") })
      }
      if (val.value === "Dashboard") {
        titems.push({ ...val, command: () => navigate("/Dashboard") })
      }

      if (val.value === "dataDomains") {
        titems.push({ ...val, command: () => navigate("/dataDomain") })
      }
    }
    if (val.id === (items.length - 1).toString()) {
      titems.push(val)
    }
  })
  console.log("titems",titems)
  return <BreadCrumb style={{ border: "1px solid #0000001A", paddingLeft: "30px", display: "flex", alignItems: "center", height: "50px", backgroundColor: "white" }} model={titems} home={home} />
}

BreadCrumbComp.propTypes = {
  items: PropTypes.object,

}
export default BreadCrumbComp